/**
 * The `disabled` a Button hands its Pressable — ALWAYS a boolean, never
 * `undefined`.
 *
 * WHY IT MATTERS (Android only, and invisible on screen). `disabled || loading`
 * with `loading` omitted is `false || undefined` → `undefined`. RN's Pressable
 * then builds an `accessibilityState` with no `disabled` key, and on Android the
 * re-render that ENABLES a button ships that state without the key — and
 * `BaseViewManager.setAccessibilityState` only calls `view.setEnabled(...)` when
 * the key is present. The native view stays `setEnabled(false)` from the
 * disabled render: it still takes taps (the press handler is JS), but
 * TalkBack announces it "disabled" and every accessibility client reads it so.
 * Measured 2026-10-12 on the Pixel AVD: the library bulk bar's Move/Delete,
 * pressable and painted enabled after Select all, reported `enabled: false`.
 * iOS rebuilds its traits from the whole state and was never affected.
 */
export function pressableDisabled(
  disabled: boolean | undefined,
  loading: boolean | undefined,
) {
  return Boolean(disabled || loading);
}
